import React, { useCallback, useEffect, useState } from 'react';

import {
  WidgetDataType,
  usePreviewSearch,
  widget,
  PageController
} from '@sitecore-search/react';
import { ArticleCard, NavMenu, Presence } from '@sitecore-search/ui';

const Articles = ({
  loading = false,
  articles,
  onItemClick,
  viewAll,
  urlViewAll
}) => (
  <NavMenu.Content className="header-search__nav-menu-grid">
    <Presence present={loading}>
      <div className="sitecore-loader-container">
        <svg
          aria-busy={loading}
          aria-hidden={!loading}
          focusable="false"
          role="progressbar"
          viewBox="0 0 20 20"
          className="header-search__loader-animation"
        >
          <path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" />
        </svg>
      </div>
    </Presence>
    <NavMenu.List className="header-search__nav-menu-sub-list">
      {!loading &&
        articles.map((article, index) => (
          <NavMenu.Item
            key={article.id}
            className="header-search__nav-menu-sub-item"
          >
            <NavMenu.Link
              href={article.url}
              onClick={e => {
                e.preventDefault();
                onItemClick({
                  id: article.id,
                  index,
                  sourceId: article.source_id
                });
                window.location.href = article.url;
              }}
              className="header-search__nav-menu-link"
            >
              <ArticleCard.Root className="header-search-root">
                {/* {article.thumbnail && (
                  <div className="header-search__article-image-wrapper">
                    <ArticleCard.Image
                      src={article.thumbnail}
                      className="header-search__article-image"
                    />
                  </div>
                )} */}
                <ArticleCard.Title className="header-search__article-name">
                  {article.name}
                </ArticleCard.Title>
              </ArticleCard.Root>
            </NavMenu.Link>
          </NavMenu.Item>
        ))}
    </NavMenu.List>
    <a className="header-search__view-all" href={urlViewAll}>
      {viewAll}
    </a>
  </NavMenu.Content>
);

export const PreviewSearchBasicComponent = ({
  defaultItemsPerPage = 6,
  inputPlaceholder,
  viewAll,
  urlViewAll,
  languageContext,
  countryContext
}) => {
  const {
    widgetRef,
    actions: { onItemClick, onKeyphraseChange },
    queryResult: {
      isFetching,
      isLoading,
      data: { content: articles = [] } = {}
    }
  } = usePreviewSearch({
    state: {
      itemsPerPage: defaultItemsPerPage
    }
  });
  const loading = isLoading || isFetching;
  const [param, setParam] = useState('');
  const keyphraseHandler = useCallback(
    event => {
      const { target } = event;
      setParam(target.value);
      onKeyphraseChange({
        keyphrase: target.value,
      });
    },
    [onKeyphraseChange]
  );

  PageController.getContext().setLocaleLanguage(languageContext);
  PageController.getContext().setLocaleCountry(countryContext);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 0) {
        const searchBtn = document.querySelector('.header__search-close');
        if (searchBtn && !searchBtn.classList.contains('focus-visible')) {
          searchBtn.click();
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
  }, []);

  return (
    <NavMenu.Root>
      <NavMenu.List className="header-search__menu-main-list">
        <NavMenu.Item className="header-search__menu-main-list-item">
          <NavMenu.InputTrigger
            onChange={keyphraseHandler}
            autoComplete="off"
            name="q"
            placeholder={inputPlaceholder}
          />
          <NavMenu.Content className="header-search__menu-main-content">
            <Presence present={loading}>
              <div className="sitecore-loader-container">
                <svg
                  aria-busy={loading}
                  aria-hidden={!loading}
                  focusable="false"
                  role="progressbar"
                  viewBox="0 0 20 20"
                  className="header-search__loader-animation"
                >
                  <path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" />
                </svg>
              </div>
            </Presence>
            {!loading && (
              <NavMenu.SubContent
                orientation="vertical"
                value="defaultArticlesResults"
                ref={widgetRef}
                className="header-search__menu-sub-content"
              >
                <NavMenu.List className="header-search__menu-main-list header-search__menu-group-list">
                  <NavMenu.Item
                    value="defaultArticlesResults"
                    key="defaultArticlesResults"
                    className="header-search__nav-menu-default-group"
                  >
                    <NavMenu.Trigger
                      aria-hidden
                      className="sitecore-nav-menu-default-trigger"
                    />
                    <Articles
                      articles={articles}
                      onItemClick={onItemClick}
                      viewAll={viewAll}
                      urlViewAll={`${urlViewAll}?q=${param}`}
                    />
                  </NavMenu.Item>
                </NavMenu.List>
              </NavMenu.SubContent>
            )}
          </NavMenu.Content>
        </NavMenu.Item>
      </NavMenu.List>
    </NavMenu.Root>
  );
};
const SearchPreviewWidget = widget(
  PreviewSearchBasicComponent,
  WidgetDataType.PREVIEW_SEARCH,
  'content'
);
export default SearchPreviewWidget;
